import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Interaction = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="m18.35 7.132 1.585-1.218A9.983 9.983 0 0 0 12 2C6.477 2 2 6.477 2 12h2a8 8 0 0 1 14.35-4.868ZM20.816 16.724l-1.762-.946A7.96 7.96 0 0 0 20 12c0-1.137-.237-2.24-.69-3.254l1.827-.815c.566 1.27.863 2.65.863 4.069 0 1.67-.41 3.283-1.184 4.724ZM2.28 14.358l1.944-.47c.157.65.395 1.276.708 1.864l-1.765.94a9.94 9.94 0 0 1-.887-2.334ZM4.923 19.065l1.415-1.413a8.01 8.01 0 0 0 2.744 1.8l-.73 1.862a10.009 10.009 0 0 1-3.43-2.25ZM10.975 19.935l-.253 1.984c.422.054.848.081 1.278.081a9.976 9.976 0 0 0 7.442-3.32l-1.488-1.337A7.976 7.976 0 0 1 12 20c-.345 0-.687-.022-1.025-.065ZM14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0ZM8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Interaction;
